import styled from 'styled-components';
import { colors, spacing, borderRadius, smallShadow } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const ImageWrapper = styled.div`
  align-items: center;
  border: solid ${spacing.single} ${colors.white};
  background: ${colors.backgroundTertiary};
  border-radius: ${borderRadius.xl};
  display: flex;
  height: ${pxToRem(40)};
  width: ${pxToRem(48)};
  justify-content: center;
  overflow: hidden;
  position: relative;
  ${smallShadow}
`;

export const PreviewImg = styled.img`
  height: 100%;
  width: 100%;
`;
